import { Component, Input } from '@angular/core';
import { SafrAdminService } from './../../../../../../admin-portal/admin/services/safr-admin.service';
import { AuditData } from '../../../../../security-admin/models/field-audit';

@Component({
    selector: 'wre-detail-history-tab',
    templateUrl: './detail-history-tab.component.html',
    styleUrls: ['./detail-history-tab.component.sass'],
    standalone: false
})
export class DetailHistoryTabComponent {

  private _fieldId: string;
  get fieldId(): string {
    return this._fieldId;
  }
  @Input() set fieldId(value: string) {
    this._fieldId = value;
    if (value != null) {
      this.loading = true;
      this.getFieldAuditData();
    }
  }

  fieldName: string;
  fieldAuditData: AuditData[];
  loading = false;
  errorMessageInfo: string;
  errorMessage: boolean;

  constructor(private _safrAdminService: SafrAdminService) { }

  getFieldAuditData() {
    this.loading = true;
    this._safrAdminService.getAuditField(this._fieldId).subscribe(
      res => {
        if (res) {
          if (res.auditData == null) {
            var auditData:AuditData[] = [{
                title:"No audit records found.",
                isCollapsable:false,
                actionBy:null, 
                date:null,
                history:null,
            }];
            this.fieldName = res.name;
            this.fieldAuditData = auditData;
            this.loading = false;
          } else {
            this.fieldAuditData = res.auditData;
            this.fieldName = res.name;
            this.loading = false;
          }
        } else {
          this.errorMessageInfo = 'An error has occured. Contact Administrator';
          this.errorMessage = true;
          this.loading = false;
        }
      })
  }
}

